/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, Inject, NgZone, ViewChild} from "@angular/core";

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {environment} from "../../../../environments/environment";
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {take} from 'rxjs/operators';
import {BaseDialogComponent} from "../../../platform/base/components/base-dialog.component";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-video-create-dialog",
	styleUrls: ["./video-create-dialog.component.css"],
	templateUrl: "./video-create-dialog.component.html",
})
export class VideoCreateDialogComponent extends BaseDialogComponent {

	public endpoint: any;
	public smVideosSide: string[] = [];
	public smVideosBack: string[] = [];
	public prizmVideos: string[] = [];
	public smImages: any[] = [];
	public prizmImages: any[] = [];
	public shots: any[] = [];
	public layouts: any[] = [];
	public selected_layout: string;

	public prizm: boolean;
	public smVideo: boolean;
	public prizmVideo: boolean;
	@ViewChild('autosize') autosize: CdkTextareaAutosize;

	/**
	 *
	 * @param data
	 * @param matDialogRef
	 * @param zone
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		private _ngZone: NgZone,
		public matDialogRef: MatDialogRef<VideoCreateDialogComponent>,
		public translate: TranslateService
	) {
		super();
		this.endpoint = environment.endPoint;

	}

	/**
	 *
	 */
	public ngOnInit(): void {
	}

	/**
	 *
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	/**
	 *
	 */
	public onAccept(): void {
		this.matDialogRef.close(this.data);
	}

	/**
	 *
	 */
	get content(): any {
		return this.data.content;
	}

	public triggerResize() {
		this._ngZone.onStable.pipe(take(1))
			.subscribe(() => this.autosize.resizeToFitContent(true));
	}
}
